import React, { useRef } from "react";
import CreditsAccordion from "../AdminCredits/Components/creditAccordionAdmin";
import CreateCreditTypeForm from "../AdminCredits/Components/createTypeCredit";
import TabMenuAdmin from "../TabMenuAdmin/TabMenuAdmin";

const parentStyles = `
  @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');

  .admin-page-container {
    padding: 24px;
    background-color: #f8fafc;
    min-height: 100vh;
    font-family: 'Plus Jakarta Sans', sans-serif;
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  .admin-page-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e2e8f0;
    padding-bottom: 16px;
    flex-wrap: wrap;
    gap: 16px;
  }

  .admin-page-title h1 {
    margin: 0;
    font-size: 1.5rem;
    font-weight: 800;
    color: #1a1d23;
  }

  .admin-page-title p {
    margin: 4px 0 0 0;
    font-size: 0.875rem;
    color: #64748b;
  }

  .admin-quick-stats {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  .admin-stat-card {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 12px 20px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02);
  }

  .admin-stat-label {
    font-size: 0.75rem;
    font-weight: 600;
    color: #94a3b8;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .admin-stat-value {
    font-size: 1.1rem;
    font-weight: 700;
    color: #0f172a;
  }

  .admin-page-content {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 16px;
    padding: 20px;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.02), 0 2px 4px -1px rgba(0, 0, 0, 0.01);
  }

  @media (max-width: 768px) {
    .admin-page-header {
      flex-direction: column;
      align-items: flex-start;
      gap: 16px;
    }
    .admin-quick-stats {
      width: 100%;
      justify-content: space-between;
      flex-wrap: wrap;
    }
  }
`;

function AdminCreditsPage(): JSX.Element {
  const accordionRef = useRef<{ reload: () => void }>(null);

  return (
    <>
      <style>{parentStyles}</style>
      <TabMenuAdmin />
      <div className="admin-page-container">
        <header className="admin-page-header">
          <div className="admin-page-title">
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
           <div className="admin-icon-box shadow-1" style={{ margin: 0, backgroundColor: '#ffffff' }}>
                <i className="pi pi-credit-card text-xl" style={{ color: '#000000' }}></i>
            </div>
            <h1 style={{ margin: 0 }}>Gestión de Créditos</h1>
            </div>
            <p>Monitorea, aprueba y desembolsa las solicitudes de crédito activas.</p>
        </div>

          <div className="admin-quick-stats">
            <div className="admin-stat-card">
              <span className="admin-stat-label">Operaciones</span>
              <span className="admin-stat-value">Mesa de Control</span>
            </div>
            <CreateCreditTypeForm onCreated={() => window.location.reload()} />
          </div>
        </header>

        <main className="admin-page-content">
          <CreditsAccordion />
        </main>
      </div>
    </>
  );
}

export default AdminCreditsPage;